import styled from 'styled-components/native'

export const Wrapper = styled.View`
  flex: 1;
  padding: 10px 30px 30px;
  gap: 40px;
`
export const IconWrapper = styled.View`
  height: 120px;
  width: 120px;
  background-color: ${({ theme }) => theme.colors.secondaryBackground};
  border-radius: ${({ theme }) => theme.borderRadius.large}px;
  justify-content: center;
  align-items: center;
  align-self: center;
`
export const ButtonWrapper = styled.View`
  align-items: center;
`
